import React from 'react';
import PropTypes from 'prop-types';
import { SnackbarProvider } from 'notistack';

import './LayoutAnonymous.scss';

const LayoutAnonymous = ({ component: Component, ...rest }) => (
  <SnackbarProvider maxSnack={5}>
    <div className="coog-layout login">
      <Component {...rest} />
    </div>
  </SnackbarProvider>
);

LayoutAnonymous.propTypes = {
  component: PropTypes.func.isRequired,
  exact: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired
};

LayoutAnonymous.defaultProps = {};

export default LayoutAnonymous;
